
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { BaseModel } from '../models/base.model';

@Component({
    selector: 'cerrix-selectable-list',
    imports: [FormsModule, MatIconModule],
    templateUrl: './cerrix-selectable-list.component.html',
    styleUrl: './cerrix-selectable-list.component.scss'
})
export class CerrixSelectableListComponent {
  @Input() public selectableList: BaseModel[] = [];
  @Input() public dataUiid: string = "undefined"
  @Output() public selectableListChange: EventEmitter<BaseModel[]> =
    new EventEmitter();

  protected selectedItems: string[] = [];

  protected searchValue: string = '';

  public getSelectedItems(): BaseModel[] {
    return this.selectableList.filter(x => this.selectedItems.includes(x.id));
  }

  protected filterList(list: BaseModel[]): BaseModel[] {
    if (this.searchValue) {
      const regExp = new RegExp(this.searchValue, 'gmi');
      return list.filter(x => x.name?.match(regExp));
    }
    return list;
  }

  protected toggleItem(itemId: string) {
    if (this.selectedItems.includes(itemId)) {
      this.selectedItems = this.selectedItems.filter(x => x !== itemId);
    } else {
      this.selectedItems.push(itemId);
    }
  }

  protected selectList(): void {
    this.selectableListChange.emit(this.getSelectedItems());
  }
}
